module.exports = __webpack_public_path__ + "media/images/navbar-logo-1ee9dcf3e8229ea228c3381b20ebeb4c.png";